import { useId } from "react"

import { useTranslation } from "react-i18next"

import type { PluginLimits } from "@/api/plugins-api"

import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

export function PluginLimitsEditor({
  value,
  onChange,
}: {
  value: PluginLimits
  onChange: (limits: PluginLimits) => void
}) {
  const { t } = useTranslation()
  const id = useId()
  const fields: { key: keyof PluginLimits; min: number; max: number }[] = [
    { key: "timeout_seconds", min: 1, max: 20 },
    { key: "response_bytes", min: 1024, max: 1048576 },
    { key: "pages", min: 1, max: 5 },
    { key: "calls", min: 1, max: 10 },
    { key: "concurrency", min: 1, max: 4 },
    { key: "per_minute", min: 1, max: 60 },
    { key: "model_bytes", min: 1024, max: 32768 },
  ]
  return (
    <details className="rounded-lg border p-3">
      <summary className="cursor-pointer text-sm font-medium">{t("plugins.limitsTitle")}</summary>
      <p className="text-muted-foreground my-2 text-xs">{t("plugins.limitsDescription")}</p>
      <div className="grid gap-3 sm:grid-cols-2">
        {fields.map(({ key, min, max }) => (
          <div key={key} className="space-y-1">
            <Label htmlFor={`${id}-${key}`}>{t(`plugins.limits.${key}`)}</Label>
            <Input
              id={`${id}-${key}`}
              max={max}
              min={min}
              step={1}
              type="number"
              value={value[key]}
              onChange={(event) => onChange({ ...value, [key]: Number(event.target.value) })}
            />
          </div>
        ))}
      </div>
    </details>
  )
}
